module.exports = __webpack_public_path__ + "static/media/background.15f92e0d.jpg";